import { Spin } from 'antd';
import { memo } from 'react';
import Loadable, { LoadingComponentProps } from 'react-loadable';

const Loading = memo((props: LoadingComponentProps) => {
    if (props.error) {
        console.error(props.error);
    }
    return (
        <Spin
            size="large"
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}
        />
    );
});
Loading.displayName = 'Loading';

const LoaderBuilder = (loader: () => Promise<any>) =>
    Loadable({ loader, loading: Loading });

export default LoaderBuilder;
